import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '@/pages/HomePage.vue';
import RulePage from '@/pages/rule/RulePage.vue';
import SearchPage from '@/pages/search/SearchPage.vue';
import SearchResultPage from '@/pages/search/SearchResultPage.vue';
import PaymentSuccessPage from '@/pages/payment/PaymentSuccessPage.vue';
import WechatOpenGuidePage from '@/pages/wechat/WechatOpenGuidePage.vue';
import { isWeChatBrowser } from '@/utils/utils';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/rule/:type?',
    name: 'rule',
    component: RulePage,
    beforeEnter(to, from, next) {
      const { type } = to.params;
      if (type) {
        next();
      } else {
        next({ name: 'home' });
      }
    },
  },
  {
    path: '/search/:type?',
    name: 'search',
    component: SearchPage,
    beforeEnter(to, from, next) {
      const { type } = to.params;
      if (type) {
        next();
      } else {
        next({ name: 'home' });
      }
    },
  },
  {
    path: '/payment-result',
    meta: {
      requiresAuth: true,
    },
    name: 'paymentResult',
    component: PaymentSuccessPage,
  },
  {
    path: '/search-result/:type?',
    // alias: '/searchResult/:type?',
    name: 'searchResult',
    component: SearchResultPage,
    beforeEnter(to, from, next) {
      const { type } = to.params;
      if (type) {
        next();
      } else {
        next({ name: 'home' });
      }
    },
  },
  {
    path: '/wechat-open-guide',
    name: 'wechatOpenGuide',
    component: WechatOpenGuidePage,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to.fullPath);
  if (isWeChatBrowser()) {
    if (to.name !== 'wechatOpenGuide') {
      next({
        name: 'wechatOpenGuide',
      });
      return;
    }
  } else if (to.name === 'wechatOpenGuide') {
    const redirectPath =
      typeof to.query.redirect === 'string' ? to.query.redirect : '';
    next(redirectPath || { name: 'home' });
    return;
  }
  next();
});

export default router;
